import { AfterContentInit, Component, ComponentFactoryResolver, ComponentRef, ContentChildren, OnInit, QueryList, ViewChild, ViewContainerRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { GlobalService } from '@solar/services/global.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';




@Component({
  selector: 'app-frms-mainhost',
  templateUrl: './mainhost.component.html',
  styleUrls: ['./mainhost.component.scss']
})
export class MainHostComponent implements OnInit,AfterContentInit {

  cmpRef: ComponentRef<any>;
  components_list:{path:string,visible:boolean, initialized:boolean}[]=[];
  supervisions:any[]=[];

  constructor(location: Location
    , private router: Router
    ,private globalService: GlobalService
    ,public dialog: MatDialog
    ,private viewContainerRef: ViewContainerRef
    ,private cfr: ComponentFactoryResolver
  ) {
    this.globalService.menuSelectedEvent.subscribe(res=>this.menuSelectedEvent_handler(res));
  }
  ngOnInit() {
    //const id = this.route1.snapshot.paramMap.get('id');

/*     let factory = this._componentFactoryResolver.resolveComponentFactory(DbOverviewComponent);
    //this.cmpRef = this.target.createComponent(factory);

    this.pageTabs = [
      {
        label: 'DashBoard',
        templateRef: this.cmpRef,
        tabTitle: 'DashBoard'
      }
    ]; */
  }
    // contentChildren are set
    ngAfterContentInit() {
      //this.getLazy1();
    }

    async getLazy1() {
      this.viewContainerRef.clear();
      const { DbOverviewComponent } = await import('../dashboard/db-overview/dboverview.component');
      this.viewContainerRef.createComponent(
        this.cfr.resolveComponentFactory(DbOverviewComponent)
      );
    }

    menuSelectedEvent_handler(item){
      console.log("menuSelectedEvent_handler: " , item);
/*        if (item.path=="/solar/dashboard"){
        this.showDashboard=true;
        this.showSiteList=false;
      }
      else if (item.path=="/solar/sites"){
        this.showDashboard=false;
        this.showSiteList=true;
      }  */

      this.showHideComponent(item.path);
    }

    private showHideComponent(path){
      let comp=this.components_list.find(item=>item.path==path);
      for (let item of this.components_list){
        item.visible=false;
      }      
      if (!comp){
        comp={path:path,visible:true, initialized:true};
        this.components_list.push(comp);
      }else{
        comp.visible=true;
      }   
    }

    componentIsLoaded(path){
      let comp=this.components_list.find(item=>item.path==path);
      if (comp){
        return true;
      }
      else{
        return false;
      }
    }
    componentIsVisible(path){
      let comp=this.components_list.find(item=>item.path==path);
      if (comp){
        return comp.visible;
      }
      else{
        return false;
      }
    }

  

  


}
